import * as React from 'react';
import './FeedbackView.scss';
import FeedbackForm from 'src/components/FeedbackForm';

interface IFeedbackViewState {
  show: boolean;
}

// This components shows or hides the FeedbackForm when a button is clicked
// This button is part of the Wordpress interface, so we need to subscribe
// our event to it manually.
const ELEMENT_ID = 'feedback-trigger';
export class FeedbackView extends React.Component<any, IFeedbackViewState> {
  public state: IFeedbackViewState = {
    show: false
  };

  private onClick = () => {
    this.setState({ show: !this.state.show }, () => {
      if (this.state.show) {
        window.scrollTo(0, 0);
      }
    });
  };

  private onClose = () => {
    this.setState({ show: false });
  };

  private subscribeEvent = (): boolean => {
    const element = document.getElementById(ELEMENT_ID);
    if (!element) {
      return false;
    }
    element.addEventListener('click', this.onClick);
    return true;
  };

  private unsubscribeEvent = () => {
    const element = document.getElementById(ELEMENT_ID);
    if (element != null) {
      element.removeEventListener('click', this.onClick);
    }
  };

  public componentDidMount() {
    // Polling until the element exists
    const interval = setInterval(() => {
      this.subscribeEvent();
    }, 1000);
  }

  public componentWillUnmount() {
    this.unsubscribeEvent();
  }

  public render() {
    return this.state.show ? <FeedbackForm onClose={this.onClose} /> : null;
  }
}
